export function getCheckedTreeKeysSessionKey(projectId: string) {
  return `project-checked-tree-keys::${projectId}`;
}
